class AssetDataRequestBody {
  ids = undefined;
  paths = []; // Required
  includeMetadata = false;
  starting = undefined; // Do not set for receiving only last data instead of the history.
  ending = undefined; // Do not set for receiving only last data instead of the history.
}

export default AssetDataRequestBody;
